import ReportForm from './ReportForm';

export default ReportForm;
